var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBackArrow = function SvgBackArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7817",
    transform: "rotate(-90 154 415.898)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(541.898 261.898)",
    fill: "#6135fb"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 488",
    d: "M560.43 275.484a.855.855 0 0 1-.659-.282l-4.049-4.049-4.05 4.049a.932.932 0 1 1-1.318-1.318l4.708-4.708a.91.91 0 0 1 1.318 0l4.708 4.708a.91.91 0 0 1 0 1.318.855.855 0 0 1-.658.282Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 489",
    d: "M555.721 282.902a.945.945 0 0 1-1-1v-10.211a1 1 0 0 1 2 0v10.21a.945.945 0 0 1-1 1.001Z"
  })))));
};

export { SvgBackArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICA8ZyBpZD0iR3JvdXBfNzgxNyIgZGF0YS1uYW1lPSJHcm91cCA3ODE3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjYxLjg5OCA1NjkuODk4KSByb3RhdGUoLTkwKSI+CiAgICA8Y2lyY2xlIGlkPSJBdmF0YXIiIGN4PSIxNCIgY3k9IjE0IiByPSIxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTQxLjg5OCAyNjEuODk4KSIgZmlsbD0iIzYxMzVmYiIvPgogICAgPGcgaWQ9InVwbG9hZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTUwLjA3MiAyNjguODkzKSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzQ4OCIgZGF0YS1uYW1lPSJQYXRoIDQ4OCIgZD0iTTE2LjE1OCw5LjU5MWEuODU1Ljg1NSwwLDAsMS0uNjU5LS4yODJMMTEuNDUsNS4yNiw3LjQsOS4zMDlBLjkzMi45MzIsMCwxLDEsNi4wODIsNy45OTFsNC43MDgtNC43MDhhLjkxLjkxLDAsMCwxLDEuMzE4LDBsNC43MDgsNC43MDhhLjkxLjkxLDAsMCwxLDAsMS4zMThBLjg1NS44NTUsMCwwLDEsMTYuMTU4LDkuNTkxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTUuOCAtMykiIGZpbGw9IiNmZmYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfNDg5IiBkYXRhLW5hbWU9IlBhdGggNDg5IiBkPSJNMTcuNSwxNS4yMTFhLjk0NS45NDUsMCwwLDEtMS0xVjRhMSwxLDAsMCwxLDIsMHYxMC4yMUEuOTQ1Ljk0NSwwLDAsMSwxNy41LDE1LjIxMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMS44NTEgLTEuMjAyKSIgZmlsbD0iI2ZmZiIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";